import { render, staticRenderFns } from "./graduation.vue?vue&type=template&id=35dc1430&scoped=true"
import script from "./graduation.vue?vue&type=script&lang=js"
export * from "./graduation.vue?vue&type=script&lang=js"
import style0 from "./graduation.vue?vue&type=style&index=0&id=35dc1430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc1430",
  null
  
)

export default component.exports